"use client";
import { useRouter } from "next/navigation";
import { BLOG_INDEX_URL } from "@/data/helpers/blog/urls";
import type { AutocompleteProps } from "@/components/ui/Autocomplete/Autocomplete";
import { scrollToResults } from "@/components/Blog/BlogSearch/utils";
import BlogAutocomplete from "@/components/Blog/BlogSearch/BlogAutocomplete";

const BlogAutocompleteStandalone = (props: AutocompleteProps) => {
  const router = useRouter();

  return (
    <BlogAutocomplete
      {...props}
      onSubmit={({ state }: { state: { query: string } }) => {
        router.push(`${BLOG_INDEX_URL}?q=${state.query}`);
        scrollToResults();
      }}
    />
  );
};

export default BlogAutocompleteStandalone;
